import React from 'react';
import { CssBaseline } from '@material-ui/core'
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Header from './Header';
import NotFound from './NotFound';
import Home from './Home';
import Room from './room/Room';
import SettingsProvider from '../contexts/SettingsProvider';
import CanvasBackground from './CanvasBackground';
import Changelog from './Changelog';

function App() {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <SettingsProvider>
        <CssBaseline />
        <Router>
          <CanvasBackground />

          <Header />
          <div style={{ flex: 1, minHeight: 0, position: 'relative', overflow: 'hidden' }}>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/room/:id" component={Room} />
              <Route path="/changelog" component={Changelog} />
              <Route path="/404" component={NotFound} />
              <Redirect to="/404" />
            </Switch>
          </div>
        </Router>
      </SettingsProvider>
    </div>
  );
}

export default App;
